import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIETag, { ETagsColorType } from '@src/shared/components/PIETag';
import React, { FC, ReactNode } from 'react';
import { ValueOf } from '../../models/model-type';
import { Statuses } from '../../models/model-constants';

interface IDashboardCustomTagProps {
  text: ReactNode | string;
  tagType: ValueOf<typeof Statuses>;
  modStrong?: boolean;
}

const tags = {
  [Statuses.Returning]: ETagsColorType.Success,
  [Statuses.Delivered]: ETagsColorType.Neutral,
  [Statuses.Assigned]: ETagsColorType.Neutral,
  [Statuses.Unassigned]: ETagsColorType.Error,
  [Statuses.InDelivery]: ETagsColorType.Neutral,
  [Statuses.AssignedToNextPool]: ETagsColorType.NeutralAlt,
  [Statuses.Nearby]: ETagsColorType.Outline,
  [Statuses.Arrived]: ETagsColorType.Success,
  [Statuses.Delayed]: ETagsColorType.Error,
} as any;

export const DashboardCustomTag: FC<IDashboardCustomTagProps> = ({ text, tagType, modStrong }) => {
  return (
    <>
      {tagType ? (
        <PIETag modStrong={modStrong} mode={tags[tagType]}>
          <PIEComponentUtil paddingRight="var(--xds-spacing-b)" paddingLeft="var(--xds-spacing-b)">
            {text}
          </PIEComponentUtil>
        </PIETag>
      ) : null}
    </>
  );
};

export default DashboardCustomTag;
